'use client';
import App from '@/App';
import store from '@/store';
import { Provider } from 'react-redux';
import React, { Fragment, ReactNode, Suspense, useEffect, useRef, useState } from 'react';
import { appWithI18Next } from 'ni18n';
import { ni18nConfig } from 'ni18n.config.ts';
import Loading from '@/components/layouts/loading';
import { showMessage } from '../global/show-message';
import { Dialog, Transition } from "@headlessui/react";
import { Button } from '../global/button';
import cookie from 'js-cookie';
import IconX from '../icon/icon-x';
import IconInfoTriangle from '../icon/icon-info-triangle';
import { useRouter } from 'next/navigation';
interface IProps {
    children?: ReactNode;
}

const ProviderComponent = ({ children }: IProps) => {

    const [isModal, setIsModal] = useState(false)
    const [secondsLeft, setSecondsLeft] = useState(30);
    const IDEAL_TIMEOUT: number = 15 * 60 * 1000

    const onTimeout = () => {
        if ((
            cookie.get('cms_user_data') ||
            cookie.get('cms_jwt_user_token') ||
            cookie.get('cms_payload_user_token') ||
            cookie.get('vendor_network_page') ||
            cookie.get('vendor_network_filters') ||
            cookie.get('vendor_network_search')
        )) {
            if (process.env.NODE_ENV != "development") {
                if (getMinuteDifference() < 15) {
                    if (timerRef.current) clearTimeout(timerRef.current);
                    timerRef.current = setTimeout(onTimeout, getMinuteDifference() * 60000);
                } else {
                    setIsModal(true)
                    timerRef.current = setTimeout(onModalTimeout, 30000);
                }
            }
        } else {
            onLogout();
            if (timerRef.current) clearTimeout(timerRef.current);
            // resetTimer()
        }
    }
    const onModalTimeout = () => {
        onLogout()
    }
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const resetTimer = () => {
        const date = Date.now().toString()
        cookie.set('cms_user_session_time', date)
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(onTimeout, IDEAL_TIMEOUT);
    };
    function getMinuteDifference() {
        const date: any = Date.now().toString()
        const sessiontime: any = cookie.get('cms_user_session_time')
        if (!sessiontime) return 15;
        const diffInMs = date - sessiontime
        const diffInMinutes = diffInMs / (60 * 1000);
        return diffInMinutes// Or Math.round(diffInMinutes) or Math.abs(diffInMinutes)
    }
    useEffect(() => {
        if (isModal) {
            setSecondsLeft(30); // Reset timer each time modal opens
            const timer = setInterval(() => {
                setSecondsLeft((prev) => {
                    const diff = getMinuteDifference()

                    if (diff < 15) {
                        setIsModal(false);
                        if (timerRef.current) clearTimeout(timerRef.current);
                        timerRef.current = setTimeout(onTimeout, diff * 60000);
                        clearInterval(timer);
                        return 2
                    }
                    if (prev <= 1) {
                        clearInterval(timer);
                        // Optional: Add your logout logic here
                        onLogout()

                        setIsModal(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer); // cleanup on unmount or close
        }
    }, [isModal]);

    useEffect(() => {

        const date = Date.now().toString()
        if (getMinuteDifference() >= 15) {
            onLogout(false);
        }
        const events = ['mousemove', 'keydown', 'click', 'scroll'];

        events.forEach(event =>
            window.addEventListener(event, resetTimer)
        );
        resetTimer(); // Start timer on mount

        return () => {
            events.forEach(event =>
                window.removeEventListener(event, resetTimer)
            );
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);
    const router = useRouter();
    const onLogout = (flag: boolean = true) => {

        if (process.env.NODE_ENV != "development") {
            cookie.remove('cms_user_data');
            cookie.remove('cms_jwt_user_token');
            cookie.remove('cms_payload_user_token');
            cookie.remove('vendor_network_page')
            cookie.remove('vendor_network_filters')
            cookie.remove('vendor_network_search')
            if (flag)
                window.location.href = 'https://www.las-ce.com/account/login';
            else
                router.push('/auth/signin');

        }
        setIsModal(false)
    }
    return (
        <Provider store={store}>
            <Suspense fallback={<Loading />}>
                <App>{children} </App>
                <Transition appear show={isModal} as={Fragment}>
                    <Dialog as="div" open={isModal} onClose={() => setIsModal(false)} className="relative z-50">
                        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                            <div className="fixed inset-0 bg-[black]/60" />
                        </Transition.Child>
                        <div className="fixed inset-0 z-[999] overflow-y-auto">
                            <div className="flex min-h-screen items-center justify-center px-4 ">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                >
                                    <Dialog.Panel className="panel my-8 w-[90%] max-w-lg overflow-hidden rounded-lg border-0 p-0 md:w-full">
                                        <button
                                            type="button"
                                            className="absolute top-4 text-primary outline-none hover:text-gray-800 dark:hover:text-gray-600 ltr:right-4 rtl:left-4"
                                            onClick={() => setIsModal(false)}
                                        >
                                            <IconX />
                                        </button>
                                        <div className="bg-[#ffe5cb] py-3 text-lg font-medium dark:bg-[#121c2c] ltr:pl-5 ltr:pr-[50px] rtl:pl-[50px] rtl:pr-5">Are you Still here?</div>
                                        <div className="p-5 text-center">
                                            <div className="mx-auto w-fit rounded-full bg-primary p-4 text-white ring-4 ring-primary/30">
                                                <IconInfoTriangle />
                                            </div>
                                            <div className="mx-auto mt-5 text-base sm:w-3/4">Are you Still here?</div>
                                            <p className=' font-extralight text-sm mt-2 text-[#999]'>
                                                You will be logged out in {secondsLeft} second{secondsLeft !== 1 && "s"}
                                            </p>
                                            <div className="mt-5 flex items-center justify-center">
                                                <Button onClick={() => setIsModal(false)} className="mr-2">
                                                    Yes
                                                </Button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition>
            </Suspense>
        </Provider>
    );
};

export default ProviderComponent;
// todo
// export default appWithI18Next(ProviderComponent, ni18nConfig);
